import React from 'react';

import { RedirectToSignIn, useAuth } from '@clerk/clerk-react';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isLoaded, userId } = useAuth();

  if (!isLoaded) {
    // Consider a better loading indicator (e.g., a spinner component from shared/ui)
    // For now, keep the simple loading text
    return <div>Loading...</div>;
  }

  if (!userId) {
    return <RedirectToSignIn />;
  }

  return children;
};

export default PrivateRoute;
